/**
 * Ad Broadcast Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { GetAdvertisedEquipmentRequest } from '../model/getAdvertisedEquipmentRequest';
import { GetAutoscoutMakesAndModelsRequest } from '../model/getAutoscoutMakesAndModelsRequest';
import { GetAutoscoutMakesAndModelsResponse } from '../model/getAutoscoutMakesAndModelsResponse';
import { GetBusinessAdvertisedImagesRequest } from '../model/getBusinessAdvertisedImagesRequest';
import { GetCaseAdvertisedImagesRequest } from '../model/getCaseAdvertisedImagesRequest';
import { GetCaseBroadcastSettingDataRequest } from '../model/getCaseBroadcastSettingDataRequest';
import { GetMobileMakesAndModelsRequest } from '../model/getMobileMakesAndModelsRequest';
import { GetMobileMakesAndModelsResponse } from '../model/getMobileMakesAndModelsResponse';
import { GetPortalStatusesDataRequest } from '../model/getPortalStatusesDataRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AdBroadcastInternalService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdPortalStatusesCaseBroadcastSettingsId(body?: GetPortalStatusesDataRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getAdPortalStatusesCaseBroadcastSettingsId(body?: GetPortalStatusesDataRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getAdPortalStatusesCaseBroadcastSettingsId(body?: GetPortalStatusesDataRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getAdPortalStatusesCaseBroadcastSettingsId(body?: GetPortalStatusesDataRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/internal/AdBroadcastInternal/GetPortalStatuses`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdvertisedEquipment(body?: GetAdvertisedEquipmentRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getAdvertisedEquipment(body?: GetAdvertisedEquipmentRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getAdvertisedEquipment(body?: GetAdvertisedEquipmentRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getAdvertisedEquipment(body?: GetAdvertisedEquipmentRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/internal/AdBroadcastInternal/GetAdvertisedEquipment`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAutoscoutMakesAndModels(body?: GetAutoscoutMakesAndModelsRequest, observe?: 'body', reportProgress?: boolean): Observable<GetAutoscoutMakesAndModelsResponse>;
    public getAutoscoutMakesAndModels(body?: GetAutoscoutMakesAndModelsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetAutoscoutMakesAndModelsResponse>>;
    public getAutoscoutMakesAndModels(body?: GetAutoscoutMakesAndModelsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetAutoscoutMakesAndModelsResponse>>;
    public getAutoscoutMakesAndModels(body?: GetAutoscoutMakesAndModelsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<GetAutoscoutMakesAndModelsResponse>(`${this.basePath}/internal/AdBroadcastInternal/GetAutoscoutMakesAndModels`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBusinessAdvertisedImages(body?: GetBusinessAdvertisedImagesRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getBusinessAdvertisedImages(body?: GetBusinessAdvertisedImagesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getBusinessAdvertisedImages(body?: GetBusinessAdvertisedImagesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getBusinessAdvertisedImages(body?: GetBusinessAdvertisedImagesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/internal/AdBroadcastInternal/GetBusinessAdvertisedImages`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCaseAdvertisedImages(body?: GetCaseAdvertisedImagesRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getCaseAdvertisedImages(body?: GetCaseAdvertisedImagesRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getCaseAdvertisedImages(body?: GetCaseAdvertisedImagesRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getCaseAdvertisedImages(body?: GetCaseAdvertisedImagesRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/internal/AdBroadcastInternal/GetCaseAdvertisedImages`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCaseBroadcastSettingData(body?: GetCaseBroadcastSettingDataRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getCaseBroadcastSettingData(body?: GetCaseBroadcastSettingDataRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getCaseBroadcastSettingData(body?: GetCaseBroadcastSettingDataRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getCaseBroadcastSettingData(body?: GetCaseBroadcastSettingDataRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/internal/AdBroadcastInternal/GetCaseBroadcastSettingData`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMobileMakesAndModels(body?: GetMobileMakesAndModelsRequest, observe?: 'body', reportProgress?: boolean): Observable<GetMobileMakesAndModelsResponse>;
    public getMobileMakesAndModels(body?: GetMobileMakesAndModelsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetMobileMakesAndModelsResponse>>;
    public getMobileMakesAndModels(body?: GetMobileMakesAndModelsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetMobileMakesAndModelsResponse>>;
    public getMobileMakesAndModels(body?: GetMobileMakesAndModelsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<GetMobileMakesAndModelsResponse>(`${this.basePath}/internal/AdBroadcastInternal/GetMobileMakesAndModels`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
